module.exports = __webpack_public_path__ + "img/logovp3_36x36.a8999f09.svg";